(() => {
  const SLOT_SELECTOR = '[data-aoy-klaviyo-form-slot]';

  function selectedForm(slot) {
    const isEventSignup = new URLSearchParams(window.location.search).get('form') === 'event';

    return {
      id: isEventSignup ? slot.dataset.eventFormId : slot.dataset.defaultFormId,
      mode: isEventSignup ? 'event' : 'collector',
    };
  }

  function mountForm(slot) {
    const form = selectedForm(slot);

    if (!form.id || !/^[A-Za-z0-9]+$/.test(form.id)) return;

    const existingForm = slot.firstElementChild;
    const expectedClass = `klaviyo-form-${form.id}`;
    slot.dataset.aoyFormMode = form.mode;

    if (existingForm && existingForm.classList.contains(expectedClass)) return;

    const formElement = document.createElement('div');
    formElement.className = expectedClass;
    formElement.dataset.aoyKlaviyoFormId = form.id;
    formElement.dataset.aoyKlaviyoFormMode = form.mode;
    slot.replaceChildren(formElement);
  }

  function mountForms(root = document) {
    root.querySelectorAll(SLOT_SELECTOR).forEach(mountForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountForms(), { once: true });
  } else {
    mountForms();
  }

  document.addEventListener('shopify:section:load', (event) => mountForms(event.target));
})();
